(() => {
  const initialized = new WeakSet();

  function initialize(form) {
    if (initialized.has(form)) return;
    const link = form.querySelector('[data-product-availability]');
    const selection = form.querySelector('variant-selection');
    if (!link || !selection) return;
    initialized.add(form);
    let revision = 0;

    function synchronize(variant) {
      const unavailable = Boolean(variant && variant.available === false);
      if (unavailable) {
        const productUrl = new URL(link.dataset.productUrl, window.location.origin);
        productUrl.searchParams.set('variant', String(variant.id));
        const contactUrl = new URL(link.dataset.contactUrl, window.location.origin);
        contactUrl.searchParams.set('product', link.dataset.productTitle);
        contactUrl.searchParams.set('ref', variant.sku || '');
        contactUrl.searchParams.set('url', productUrl.toString());
        link.href = contactUrl.toString();
      }
      form.classList.toggle('availability-request-active', unavailable);
    }

    selection.addEventListener('variant-change', event => {
      revision += 1;
      synchronize(event.detail.variant);
    });

    customElements.whenDefined('variant-selection').then(() => {
      const initialRevision = revision;
      return selection.getVariant().then(variant => {
        if (variant && revision === initialRevision) synchronize(variant);
      });
    }).catch(() => {});
  }

  function scan(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element) {
      if (root.matches('[data-product-form]')) initialize(root);
      if (root.matches('[data-product-availability]')) {
        const form = root.closest('[data-product-form]');
        if (form) initialize(form);
      }
    }
    root.querySelectorAll('[data-product-form]').forEach(initialize);
  }

  function start() {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
